import { Outlet } from "react-router-dom";
const ReportLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ReportLayout;
